import { STATUS_STYLES } from "../lib/format";

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded ${
      STATUS_STYLES[status] || "text-zinc-400 bg-zinc-400/10 border-zinc-400/20"
    }`}
  >
    {status}
  </span>
);
